import list from './list'
import activitiesList from './activities'

export default {
    list,
    activitiesList,
}
